module.exports = __webpack_public_path__ + "img/hr-green-small-grass-07.709a4243.png";